<template>
    <div v-if="canBeDeleted">
        <a href="#" @click="showConfirmationModal()">
            <i class="fas fa-fw fa-trash-alt text-danger"></i>
        </a>
    </div>
</template>

<script>
export default {
    name: 'DeleteClientHandler',

    props: {
        id: 0,
        canBeDeleted: false,
    },

    methods: {
        showConfirmationModal() {
            this.$bvModal
                .msgBoxConfirm(
                    'Etes vous sûr·e de vouloir supprimer ce client ?',
                    {
                        title: 'Confirmation',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        okTitle: 'Supprimer',
                        cancelTitle: 'Annuler',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true,
                        noFade: false,
                    }
                )
                .then((value) => {
                    //
                    if (value) {
                        this.deleteItem()
                    }
                })
                .catch((err) => {
                    // An error occurred
                })
        },

        async deleteItem() {
            try {
                await axios.delete(`/clients/${this.id}`)
                this.$root.$refs.clientsTable.getItems()
            } catch (error) {
                console.log(error)
            }
        },
    },
}
</script>

<style scoped></style>
